export default __webpack_public_path__ + "static/media/WIBS_light.7ba9d66e.png";